@if (reportsCategoryBreakDown) {
  <h2 class="heading">{{ reportsCategoryBreakDown.heading }}:</h2>
  <mat-divider />
  <section class="header flex">
    <h3 class="flex flex-item medium">
      <p class="small-font">{{ categoryBreakdownTitles.YEAR }}</p>
      <p class="bold medium-font">{{ reportsCategoryBreakDown.year }}</p>
    </h3>
    <h3 class="flex flex-item medium">
      <p class="small-font">{{ categoryBreakdownTitles.FUNDS }}</p>
      <p class="bold medium-font">
        {{
          (reportsCategoryBreakDown.totalAllocations
            ? reportsCategoryBreakDown.totalAllocations
            : 0
          ) | customCurrency
        }}
      </p>
    </h3>
    <h3 class="flex flex-item large">
      <p class="small-font">{{ categoryBreakdownTitles.STUDENTS }}</p>
      <p class="bold medium-font">
        {{ reportsCategoryBreakDown.totalNumberOfActiveStudents }}
      </p>
    </h3>
  </section>
  @if (showCategoryBreakdown) {
    <p class="race-percentage-title bold">
      {{ categoryBreakdownTitles.PERCENTAGES }}
    </p>
  }
  @if (showCategoryBreakdown) {
    <section class="divider-bars">
      @for (
        detail of reportsCategoryBreakDown.totalPerRace;
        track detail;
        let i = $index
      ) {
        <mat-divider
          id="progressBarMatDivider"
          [ngStyle]="{
            width: getDividerWidth(detail.race, detail),
            top: getDividerIndexAndTop(i).top,
            'z-index': getDividerIndexAndTop(i).index
          }"
          [ngClass]="{
            white: detail.race.toLocaleLowerCase() === races.WHITE,
            black: detail.race.toLocaleLowerCase() === races.BLACK,
            indian: detail.race.toLocaleLowerCase() === races.INDIAN,
            coloured: detail.race.toLocaleLowerCase() === races.COLOURED
          }"
        />
      }
    </section>
  }
  @if (showCategoryBreakdown) {
    <section class="categories flex">
      @for (
        raceDetail of reportsCategoryBreakDown.totalPerRace;
        track raceDetail;
        let i = $index
      ) {
        <section class="race-details flex">
          <mat-divider
            [vertical]="true"
            id="matDivider"
            [ngClass]="{
              white: raceDetail.race.toLocaleLowerCase() === races.WHITE,
              black: raceDetail.race.toLocaleLowerCase() === races.BLACK,
              indian: raceDetail.race.toLocaleLowerCase() === races.INDIAN,
              coloured: raceDetail.race.toLocaleLowerCase() === races.COLOURED
            }"
          ></mat-divider>
          <section>
            <p class="small-font">{{ raceDetail.race }}</p>
            <p>
              <span class="bold medium-font"
                >{{ raceDetail.ratio | number: "1.0-2" }}%</span
              >
              <span class="bold medium-font">({{ raceDetail.count }})</span>
            </p>
          </section>
        </section>
      }
    </section>
  }
}
<mat-divider />
